export const brandConstants = {
  FETCH_REQUEST: 'BRAND_FETCH_REQUEST',
  FETCH_SUCCESS: 'BRAND_FETCH_SUCCESS',
  FETCH_FAILURE: 'BRAND_FETCH_FAILURE',
};
